import { ECOM_ORDER_STATUS } from './constants'
import type { Product, ProductExtended } from './types'

export const inventoryStringMatcher = (listItem: Product | ProductExtended) => [
  listItem.name,
  listItem.manufacturerProductNo,
  listItem.code,
  listItem.sku,
  listItem.alias,
]

export const getIsInStock = (product: Product | ProductExtended) =>
  Boolean(parseInStock(product.inStock) !== '0')

export const parseInStock = (inStock: string | null) => {
  if (inStock === null) return '0'

  const inStockWithoutSigns = inStock?.replace(/\+|</, '') || 0
  const inStockNumber = Number(inStockWithoutSigns)

  return inStockNumber > 0 ? inStock : '0'
}

export const getNumberOfProductsInStock = <T extends Product | ProductExtended>(
  productsList: T[]
): string => {
  const numberOfProductsInStock = productsList.reduce((acc, { inStock }) => {
    const inStockParsed = inStock?.replace(/\+|</, '') || 0

    // disabling due to reduce func
    // eslint-disable-next-line no-param-reassign
    acc += Number(inStockParsed)
    return acc
  }, 0)

  return numberOfProductsInStock > 0 ? `${numberOfProductsInStock}+` : '0'
}

export const getStatusName = (statusId: number) => {
  switch (statusId) {
    case ECOM_ORDER_STATUS.NEW:
      return 'NEW'
    case ECOM_ORDER_STATUS.ACCEPTED:
      return 'ACCEPTED'
    case ECOM_ORDER_STATUS.CONFIRMED:
      return 'CONFIRMED'
    case ECOM_ORDER_STATUS.DELIVERED:
      return 'DELIVERED'
    case ECOM_ORDER_STATUS.PARTIALLY_DELIVERED:
      return 'PARTIALLY_DELIVERED'
    case ECOM_ORDER_STATUS.AWAITING_APPROVAL:
      return 'AWAITING_APPROVAL'
    case ECOM_ORDER_STATUS.REJECTED:
      return 'REJECTED'
    case ECOM_ORDER_STATUS.PENDING_DEALER_APPROVAL:
      return 'PENDING_DEALER_APPROVAL'
    case ECOM_ORDER_STATUS.DELAYED:
      return 'DELAYED'
    case ECOM_ORDER_STATUS.CANCELED:
      return 'CANCELED'
    case ECOM_ORDER_STATUS.ASSET_MIGRATION:
      return 'ASSET_MIGRATION'
    case ECOM_ORDER_STATUS.CREDIT_REJECTED:
      return 'CREDIT_REJECTED'
    case ECOM_ORDER_STATUS.PRICE_CHANGED:
      return 'PRICE_CHANGED'
    case ECOM_ORDER_STATUS.ERROR:
      return 'ERROR'
    default:
      return 'Unknown status'
  }
}
